/* eslint-disable react/no-children-prop */
import {
  CloseCircleOutlined,
  CloseOutlined,
  ExclamationCircleFilled,
  InfoCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/client";
import {
  Badge,
  Button,
  Checkbox,
  Dropdown,
  Input,
  List,
  message,
  Modal,
  Popover,
  Radio,
  Tag,
  Tooltip,
  Pagination,
} from "antd";
import dayjs from "dayjs";
import { isEmpty, isFunction, isUndefined, orderBy } from "lodash";
import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LuX } from "react-icons/lu";
import { PiUserCircle, PiUserCircleDashed } from "react-icons/pi";
import { UserContext } from "../../../amplify/authenticator-provider";
import { colorCode, PROJECT_NAME_V2 } from "../../../config";
import { UPDATE_LEAD_ARCHIVE_STATUS } from "../../../graphql/mutation";
import useLang from "../../../hooks/useLang";
import ArchiveIcon from "../../../icons/js/ArchiveIcon";
import LeadOppTypeIcons from "./LeadOppTypeIcons";
import FilterIcon from "../../../icons/js/FilterIcon";
import RestoreArchiveIcon from "../../../icons/js/RestoreArchive";
import SortIcon from "../../../icons/js/SortIcon";
import { parseTimestamp } from "../../../library/utils";
import {
  getDefaultTabId,
  getMostRecentPermittedRootOppTypeId,
  oppMatchesTab,
} from "../../../library/oppTypeScoping";
import { getCacheApi, setSelectedLeadPhone } from "../../../redux/slices/apiCacheSlice";
import { resetAiResponseHistoryIds } from "../../../redux/slices/aiSlice";
import {
  AccessPermissionAction,
  SEARCH_SCOPE,
  SEARCH_SCOPE_OPTIONS,
} from "../../../library/constants";
import { CustomRadioGroup } from "../../commonComponents/CustomRadio";
import { checkAccessPermission } from "../../../library/helpers";
import {
  addQuickFilter,
  removeMyConversationFlag,
  removeQuickFilter,
  resetLeadFilters,
  setLeadSortOrder,
  setSearchRedux,
  setSearchAllLeads,
  changeMessageOpportunity,
  QUICK_FILTERS,
  getQuickFilterChipClass,
  getQuickFilterDotColor,
} from "../../../redux/slices/leadSlice";
import AntdIconV4 from "../../../utils/antdIcon";
import CustomLabel from "../../commonComponents/label";
import { getOpportunityStatusPath, statusColor } from "./engagementHelpers";
import ActivityCenterFilter from "./ActivityCenterFilter";
import LeadList from "./leadList";
import DownIcon from "../../../icons/DownIcon";
import useBrowserExt from "../../../hooks/useBrowserExt";
import { useWindowSize } from "../../../hooks/personalizedHooks";
import { GET_OPPORTUNITY_STATUS } from "../../../graphql/query";
import useDebounce from "../../../hooks/debounceHook";
import {
  getLocalStorage,
  setLocalStorage,
  SKIP_ARCHIVE_RESTORE_CONFIRMATION_KEY,
} from "../../../utils/storages";

const MIN_SEARCH_LENGTH = 3;
const SEARCH_DEBOUNCE_MS = 400;

// Lead-card left-strip color resolver. Priority per product decision:
//   1. NO_RESPONSE_NEEDED  — wins outright if present in ANY of the three
//                            fields (engagementStatus / replyState /
//                            messageStatusType).
//   2. NOT_RESPONDED       — when engagementStatus says so (overrides
//                            replyState).
//   3. replyState          — WAITING_FOR_REPLY / NEEDS_YOUR_REPLY.
//   4. engagementStatus    — remaining values (UNCONTACTED / RESPONDED /
//                            NOT_ENGAGED / ENGAGED).
//   5. Fallback            — UNCONTACTED.
const resolveLeadStripStatus = lead => {
  const engagementStatus = lead?.leadMessageSummary?.engagementStatus;
  const replyState = lead?.leadMessageSummary?.replyState;
  const messageStatus = lead?.messageStatusType?.status;

  if (
    engagementStatus === QUICK_FILTERS.NO_RESPONSE_NEEDED ||
    replyState === QUICK_FILTERS.NO_RESPONSE_NEEDED ||
    messageStatus === QUICK_FILTERS.NO_RESPONSE_NEEDED
  ) {
    return QUICK_FILTERS.NO_RESPONSE_NEEDED;
  }

  if (engagementStatus === QUICK_FILTERS.NOT_RESPONDED) return QUICK_FILTERS.NOT_RESPONDED;

  if (replyState === QUICK_FILTERS.WAITING_FOR_REPLY) return QUICK_FILTERS.WAITING_FOR_REPLY;
  if (replyState === QUICK_FILTERS.NEEDS_YOUR_REPLY) return QUICK_FILTERS.NEEDS_YOUR_REPLY;

  if (engagementStatus === QUICK_FILTERS.UNCONTACTED) return QUICK_FILTERS.UNCONTACTED;
  if (engagementStatus === QUICK_FILTERS.RESPONDED) return QUICK_FILTERS.RESPONDED;
  if (engagementStatus === QUICK_FILTERS.NOT_ENGAGED) return QUICK_FILTERS.NOT_ENGAGED;
  if (engagementStatus === QUICK_FILTERS.ENGAGED) return QUICK_FILTERS.ENGAGED;

  return QUICK_FILTERS.UNCONTACTED;
};

const LeadListContainer = props => {
  const {
    setShowLeadSection,
    selectedLead,
    leadsLoading,
    leadList,
    setLeadList,
    variables,
    leadCount,
    setVariables,
    setSelectedLead,
    setMessageFilters,
    messageFilters,
    sourcesData,
    searchKey,
    handleSearch,
    setSearchKey,
    activeOpp,
    setActiveOpp,
    opportunityList,
    timeReference,
    setOpportunityList,
    setFilterApplied,
    handleOppFilter,
    handleStatusFilter,
    leadStatus,
    selectedStatus,
    setSelectedStatus,
    openAppointmentPopup,
    handleAppointmentModalClose,
    setSelectedLeadId,
    setbtnClicked,
    setActiveLeadId,
    handleScrollOnMovement,
    changePage,
    setQueryString = () => {},
    isFromChatbot = false,
    handleLeadListVisible,
    IsLeadListVisible,
    spinner,
    campaignFilters,
    queryString,
    entityId,
    eventId,
    handleLeadListDrawer = () => {},
    onClose,
    setAttachments,
    refetchLeads,
    setmessageText = () => {},
    setSummaryVisible,
    handleUnpinLead = () => {},
    selectedLeadsFromLeadCenter = [],
    getDuplicateLeads = () => {},
    getMergedLead = () => {},
    removeMergedLead = () => {},
    onClearAllFilters,
    isSingleLeadView = false,
    onLoadAllLeads = () => {},
    selectedOppTypeId = null,
    setSelectedOppTypeId = () => {},
    listFilterRootOppTypeIds = [],
  } = props;
  const { isBrowserExt } = useBrowserExt();
  const { width, height } = useWindowSize();
  const quickFilters = [
    {
      title: "Inbox",
      backgroundColor: "processing",
      value: "RESPONDED",
    },
    {
      title: "Sent",
      backgroundColor: "success",
      value: "WAITING_FOR_REPLY",
    },
    {
      title: "Archived",
      backgroundColor: "error",
      value: "NO_RESPONSE_NEEDED",
    },
  ];
  const urlParams = new URLSearchParams(window.location.search);
  const presetLeadFilter = urlParams.get("presetFilter");

  const { user, modal, newLead, setNewLead, addnewLead, setAddNewLead } = useContext(UserContext);
  const dispatch = useDispatch();
  const [lang] = useLang();
  const selectedLeadPhoneReduxData = useSelector(state => getCacheApi(state, "selectedLeadPhone"));
  const {
    quickFilters: selectedQuickFilters,
    userFilters,
    teamFilters = [],
    dateFilterType = "",
    dateRange: leadDateRange = [],
    opportunityTypeFilterCount,
    opportunityStatusFilterCount,
    opportunitySourceFilterCount,
    campaignFilters: reduxCampaignFilters,
  } = useSelector(state => state.lead.filters);
  const { leads, leadSort, search } = useSelector(state => state.lead);
  const [visible, setVisible] = useState(false);
  const [leadData, setLeadData] = useState([]);
  // Per-lead "Show All / Close" merge-banner state, keyed by stable lead id
  // (NOT list index — see banner). Absent id = collapsed → defaults to "Show All".
  const [showAll, setShowAll] = useState({});
  const [noResponseNeededLoading, setNoResponseNeededLoading] = useState(false);
  const [archivingLeadId, setArchivingLeadId] = useState(null);
  const [opportunityStatusList, setOpportunityStatusList] = useState([]);
  const listContainerRef = useRef(null);

  const scrollListToTop = () => {
    if (listContainerRef.current) {
      listContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const { loading: opportunityStatusLoader } = useQuery(GET_OPPORTUNITY_STATUS, {
    variables: {
      fetchAll: true,
      locationIds: (sessionStorage?.getItem("currentLocationId") || "").includes(",")
        ? sessionStorage
            ?.getItem("currentLocationId")
            ?.split(",")
            .map(el => +el)
        : [+sessionStorage?.getItem("currentLocationId")],
    },
    onCompleted: resp => {
      setOpportunityStatusList(resp.getOpportunityStatus || []);
    },
  });

  const [setLeadAsNoResponseNeeded] = useMutation(UPDATE_LEAD_ARCHIVE_STATUS, {
    onCompleted: resp => {
      setArchivingLeadId(null);
      if (resp?.updateLeadArchiveStatus?.statusCode === 200) {
        message.success(resp?.updateLeadArchiveStatus?.message || "");
        setNoResponseNeededLoading(false);
        refetchLeads();
      } else {
        message.error(resp?.updateLeadArchiveStatus?.message || "");
      }
    },
    onError: () => {
      setArchivingLeadId(null);
    },
  });
  const handleVisibleChange = () => {
    setVisible(!visible);
  };

  const clearUrl = () => {
    if (window.location.search) {
      if (window.location.pathname?.includes("browser-ext")) {
        window.history.pushState("", "", "/browser-ext");
      } else {
        window.history.pushState("", "", "/engagements/activity-center");
      }
    }
  };

  // Date tab counts as "1" when any selection is committed (preset OR
  // complete custom range) — mirrors the per-tab `dateFilterCount` in
  // ActivityCenterFilter.
  const dateFilterCount =
    dateFilterType || (Array.isArray(leadDateRange) && leadDateRange.length === 2) ? 1 : 0;

  // When the workspace force-applies MY_CONVERSATIONS as a permission
  // default, exclude it from the visible badge count so the chip reflects
  // only the filters the user actually picked. Inlined so we don't depend
  // on the `restrictRemoveDefaultFilter` const declared further down.
  const isMyConversationsRestricted = checkAccessPermission(
    AccessPermissionAction.ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER
  );
  // Dedupe the status set — `selectedStatus` (local) and
  // `selectedQuickFilters` (redux) can hold the same ids (the BE payload
  // already unions them via `uniq([...selectedQuickFilters, ...selectedStatus])`).
  // Count once per unique id so the badge matches the per-tab chips.
  const statusUnion = new Set([...(selectedQuickFilters || []), ...(selectedStatus || [])]);
  if (isMyConversationsRestricted) statusUnion.delete(QUICK_FILTERS.MY_CONVERSATIONS);

  const filterCount =
    (reduxCampaignFilters || []).length +
    (variables.search && variables.search !== "undefined" ? 1 : 0) +
    (presetLeadFilter && presetLeadFilter !== "undefined" ? 1 : 0) +
    statusUnion.size +
    (userFilters || []).length +
    (teamFilters || []).length +
    dateFilterCount +
    (opportunityTypeFilterCount || 0) +
    (opportunityStatusFilterCount || 0) +
    (opportunitySourceFilterCount || 0);

  useEffect(() => {
    if (newLead !== null && addnewLead) {
      const array = () => {
        const temp = structuredClone(leads);
        newLead.fullName = newLead.full_name;
        temp.unshift(newLead);
        return [...temp];
      };
      setLeadList(array());
      setAddNewLead(false);
      setNewLead(null);
    }
  }, [newLead, addnewLead]);

  useEffect(() => {
    setSearchKey(selectedLeadPhoneReduxData);
  }, [selectedLeadPhoneReduxData]);

  useEffect(() => {
    if (!window.location.search) dispatch(setSelectedLeadPhone({ selectedLeadPhone: searchKey }));
    // return () => dispatch(setSelectedLeadPhone({ selectedLeadPhone: "" }));
  }, [searchKey]);

  useEffect(() => {
    return () => dispatch(setSelectedLeadPhone({ selectedLeadPhone: "" }));
  }, []);

  useEffect(() => {
    setLeadData(leadList);
  }, [leadList]);

  const setSearch = search => {
    setVariables({ ...variables, page: 1 });
    dispatch(setSearchRedux(search));
    scrollListToTop();
  };
  const SortOptionsContainer = () => {
    const [sortOption, setsortOption] = useState(leadSort);
    // prioritySortOrder
    return (
      <>
        <h3>Sort options</h3>
        <Radio.Group
          value={sortOption}
          onChange={e => {
            setsortOption(e.target.value);
            dispatch(setLeadSortOrder(e.target.value));
            scrollListToTop();
          }}
          className="flex flex-col"
        >
          <Radio value="default">
            {PROJECT_NAME_V2} Sort{" "}
            <Tooltip title="Sorts leads that require immediate action, including pending replies and follow-ups, to the top.">
              <InfoCircleOutlined className="icon-color" />
            </Tooltip>{" "}
          </Radio>
          <Radio value="lastMessage">
            Most Recent Message{" "}
            <Tooltip placement="bottom" title="Sort by latest activities">
              <InfoCircleOutlined className="icon-color" />
            </Tooltip>{" "}
          </Radio>
        </Radio.Group>
      </>
    );
  };

  // Single source of truth — chip classes come from the shared
  // quickFilterColors map so the dropdown chips, the per-status pills, and
  // the ActivityCenterFilter > Quick filters dots all stay in sync.
  const backgroundColor = id => getQuickFilterChipClass(id);

  const canMergeOppor = checkAccessPermission(AccessPermissionAction.MERGE_LEADS_OPPS);
  const restrictRemoveDefaultFilter = checkAccessPermission(
    AccessPermissionAction.ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER
  );

  const isMyConversationRestricted = itemId =>
    restrictRemoveDefaultFilter && itemId === QUICK_FILTERS.MY_CONVERSATIONS;

  const renderFilters = leadStatus.map(item => ({
    label: (
      <Checkbox
        onClick={e => e.stopPropagation()}
        onChange={e => {
          if (isMyConversationRestricted(item.id) && !e.target.checked) return;
          if (setVariables) {
            setVariables({
              ...variables,
              leadId: null,
              page: 1,
            });
          }
          if (e.target.checked) {
            dispatch(addQuickFilter(item.id));
          } else {
            dispatch(removeQuickFilter(item.id));
          }
          scrollListToTop();
          clearUrl();
        }}
        checked={selectedQuickFilters.includes(item.id)}
        disabled={isMyConversationRestricted(item.id) && selectedQuickFilters.includes(item.id)}
      >
        <span onClick={e => e.stopPropagation()} className={`${backgroundColor(item.id)}`}>
          {item.name}
        </span>
      </Checkbox>
    ),
    key: item.id,
  }));

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <TopLeadFilters
        lang={lang}
        search={search}
        isFromChatbot={isFromChatbot}
        setSearchKey={setSearchKey}
        setQueryString={setQueryString}
        handleSearch={handleSearch}
        setSearch={setSearch}
        SortOptionsContainer={SortOptionsContainer}
        visible={visible}
        handleVisibleChange={handleVisibleChange}
        variables={variables}
        setVariables={setVariables}
        opportunityList={opportunityList}
        activeOpp={activeOpp}
        handleOppFilter={handleOppFilter}
        setActiveOpp={setActiveOpp}
        setShowLeadSection={setShowLeadSection}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        leadStatus={leadStatus}
        handleStatusFilter={handleStatusFilter}
        campaignFilters={campaignFilters}
        queryString={queryString}
        entityId={entityId}
        eventId={eventId}
        filterCount={filterCount}
        renderFilters={renderFilters}
        dispatch={dispatch}
        selectedQuickFilters={selectedQuickFilters}
        backgroundColor={backgroundColor}
        scrollListToTop={scrollListToTop}
        clearUrl={clearUrl}
        restrictRemoveDefaultFilter={restrictRemoveDefaultFilter}
        onClearAllFilters={onClearAllFilters}
      />

      <div ref={listContainerRef} className="overflow-y-auto flex-grow list-border-bottom">
        <List
          className="cursor-pointer"
          itemLayout="horizontal"
          loading={leadsLoading}
          dataSource={leadData}
          renderItem={item => {
            const isPinLeadFromLeadCenter =
              (selectedLeadsFromLeadCenter || []).findIndex(el => el?.id === item?.id) > -1;

            return (
              <ListItem
                item={item}
                selectedLead={selectedLead}
                setSummaryVisible={setSummaryVisible}
                user={user}
                isFromChatbot={isFromChatbot}
                sourcesData={sourcesData}
                activeOpp={activeOpp}
                setActiveOpp={oppr => {
                  setActiveOpp(oppr);
                  dispatch(changeMessageOpportunity(oppr));
                }}
                openAppointmentPopup={openAppointmentPopup}
                handleAppointmentModalClose={handleAppointmentModalClose}
                spinner={spinner}
                refetchLeads={refetchLeads}
                setAttachments={setAttachments}
                setmessageText={setmessageText}
                setSelectedLead={setSelectedLead}
                changePage={changePage}
                messageFilters={messageFilters}
                setMessageFilters={setMessageFilters}
                setShowLeadSection={setShowLeadSection}
                setOpportunityList={setOpportunityList}
                setFilterApplied={setFilterApplied}
                setSelectedLeadId={setSelectedLeadId}
                timeReference={timeReference}
                setbtnClicked={setbtnClicked}
                handleLeadListDrawer={handleLeadListDrawer}
                handleUnpinLead={handleUnpinLead}
                isPinLeadFromLeadCenter={isPinLeadFromLeadCenter}
                lang={lang}
                setLeadAsNoResponseNeeded={setLeadAsNoResponseNeeded}
                setNoResponseNeededLoading={setNoResponseNeededLoading}
                archivingLeadId={archivingLeadId}
                setArchivingLeadId={setArchivingLeadId}
                getDuplicateLeads={getDuplicateLeads}
                getMergedLead={getMergedLead}
                removeMergedLead={removeMergedLead}
                showAll={showAll}
                leadData={leadData}
                setShowAll={setShowAll}
                canMergeOppor={canMergeOppor}
                opportunityStatusList={opportunityStatusList}
                selectedOppTypeId={selectedOppTypeId}
                setSelectedOppTypeId={setSelectedOppTypeId}
                listFilterRootOppTypeIds={listFilterRootOppTypeIds}
              />
            );
          }}
        />
        {isSingleLeadView && (
          <div className="flex justify-center py-2 px-4">
            <Button type="link" className="!font-medium" block onClick={onLoadAllLeads}>
              Show all leads
            </Button>
          </div>
        )}
      </div>

      {!isEmpty(leadData) && leadCount > 5 && !leadsLoading && (
        <div className="pt-3 pb-2 sticky-pagination">
          <Pagination
            current={variables.page}
            pageSize={variables.pageSize}
            total={leadCount}
            align="center"
            pageSizeOptions={["5", "25", "50"]}
            showSizeChanger
            onChange={(page, pageSize) => {
              const newVariables = {
                ...variables,
                page,
                pageSize,
              };
              localStorage.removeItem("clickLeadId");
              setVariables(newVariables);
              setActiveOpp("#DEFAULTOPPID");
              handleScrollOnMovement();
              setSelectedLead({});
              localStorage.removeItem("changedLocationLeadId");
              setActiveLeadId(false);
              setLeadData([]);
            }}
            onShowSizeChange={(current, size) => {
              const newVariables = {
                ...variables,
                page: current,
                pageSize: size,
              };
              localStorage.removeItem("clickLeadId");
              setVariables(newVariables);
            }}
            size="small"
            className="!pb-1"
            showLessItems={window.location.pathname.includes("browser-ext") || width < 768}
          />
          <p className="text-center m-0 text-base font-normal">
            {lang.total}: {leadCount} {leadCount === 1 ? lang.lead : lang.leads}
          </p>
        </div>
      )}
    </div>
  );
};

export default LeadListContainer;
function TopLeadFilters({
  lang,
  search,
  isFromChatbot,
  setSearchKey,
  setQueryString,
  handleSearch,
  setSearch,
  SortOptionsContainer,
  visible,
  handleVisibleChange,
  variables,
  setVariables,
  opportunityList,
  activeOpp,
  handleOppFilter,
  setActiveOpp,
  setShowLeadSection,
  selectedStatus,
  setSelectedStatus,
  leadStatus,
  handleStatusFilter,
  campaignFilters,
  queryString,
  entityId,
  eventId,
  filterCount,
  renderFilters,
  dispatch,
  selectedQuickFilters,
  backgroundColor,
  scrollListToTop,
  clearUrl,
  restrictRemoveDefaultFilter,
  onClearAllFilters,
}) {
  const [localSearch, setLocalSearch] = useState(search || "");
  const lastDispatchedRef = useRef(search || "");

  // Search scope: true = "All Leads" (skipFilter on the BE), false = "Within
  // Filtered Lead". Lives in Redux so the getLeads query in engagementActivity
  // can read it directly.
  const searchAllLeads = useSelector(state => state.lead.searchAllLeads);
  const [scopePopoverOpen, setScopePopoverOpen] = useState(false);

  const handleSearchScopeChange = e => {
    const isAll = e.target.value === SEARCH_SCOPE.ALL;
    dispatch(setSearchAllLeads(isAll));
    // Close the popover once a scope is chosen.
    setScopePopoverOpen(false);
    // If a search is active, re-run it so the new scope takes effect now.
    const trimmed = localSearch?.trim() || "";
    if (trimmed.length >= MIN_SEARCH_LENGTH) {
      handleSearch(trimmed);
      scrollListToTop();
    }
  };

  const searchScopeContent = (
    <div className="w-[260px] py-1">
      <p className="px-1 m-0 mb-2 text-xs font-semibold tracking-wide text-black-45 uppercase">
        Search Scope
      </p>
      <CustomRadioGroup
        options={SEARCH_SCOPE_OPTIONS}
        value={searchAllLeads ? SEARCH_SCOPE.ALL : SEARCH_SCOPE.FILTERED}
        onChange={handleSearchScopeChange}
      />
    </div>
  );

  // Sync local state when Redux search changes externally (e.g., URL navigation)
  useEffect(() => {
    if (search !== lastDispatchedRef.current) {
      setLocalSearch(search || "");
      lastDispatchedRef.current = search || "";
    }
  }, [search]);

  const debouncedSearch = useDebounce(value => {
    const trimmed = value?.trim() || "";
    // Only trigger API if >= MIN_SEARCH_LENGTH chars, or empty (to clear results)
    if (trimmed.length >= MIN_SEARCH_LENGTH) {
      if (lastDispatchedRef.current !== trimmed) {
        lastDispatchedRef.current = trimmed;
        handleSearch(trimmed);
        scrollListToTop();
      }
    } else if (trimmed.length === 0 && lastDispatchedRef.current !== "") {
      lastDispatchedRef.current = "";
      handleSearch("");
      scrollListToTop();
    }
  }, SEARCH_DEBOUNCE_MS);

  const updateVariableContext = () => {
    if (setVariables) {
      setVariables({
        ...variables,
        leadId: null,
        page: 1,
      });
    }
  };

  return (
    <div className="sticky top-0 bg-white z-[999]">
      <div className="flex items-center">
        <Input
          data-testid="lead-search-input"
          size="large"
          placeholder={lang.searchLeadBy}
          name="search"
          className="z-10 bg-white"
          // Keep `suffix` always present (stable wrapper) so antd doesn't
          // remount the <input> when the clear icon appears/disappears — that
          // remount was stealing focus after the first character.
          suffix={
            <span data-testid="lead-search-clear">
              {!isEmpty(localSearch) && (
                <LuX
                  onClick={() => {
                    isFromChatbot && window.parent.postMessage(localSearch, "*");
                    setLocalSearch("");
                    lastDispatchedRef.current = "";
                    setSearchKey("");
                    setQueryString("");
                    handleSearch("");
                    setSearch("");
                    localStorage.setItem("previousLeadSearchTrack", "");
                  }}
                  className="cursor-pointer mb-[-3px] text-black-65 text-lg mr-[2px]"
                />
              )}
            </span>
          }
          // Scope toggle lives in its own bordered cell (antd `addonAfter`) so
          // it reads as a distinct control, separated from the search field.
          addonAfter={
            <Popover
              trigger="click"
              placement="bottomRight"
              content={searchScopeContent}
              overlayInnerStyle={{ padding: "10px 12px" }}
              open={scopePopoverOpen}
              onOpenChange={setScopePopoverOpen}
            >
              <span
                data-testid="lead-search-scope"
                className="flex items-center cursor-pointer"
                onClick={e => e.stopPropagation()}
              >
                <Tooltip title="Search scope">
                  {searchAllLeads ? (
                    <PiUserCircle className="text-[18px] text-black" />
                  ) : (
                    <PiUserCircleDashed className="text-[18px] text-black" />
                  )}
                </Tooltip>
              </span>
            </Popover>
          }
          value={localSearch}
          onChange={e => {
            const { value } = e.target;
            setLocalSearch(value);

            if (isEmpty(value)) {
              if (window.location.pathname.includes("browser-ext")) {
                window.history.pushState("", "", `/browser-ext/`);
              } else {
                window.history.pushState("", "", `/engagements/activity-center`);
              }
            }
            if (isFunction(clearUrl)) {
              clearUrl();
            }
            debouncedSearch(value);
          }}
        />
        <Popover trigger="click" placement="right" content={<SortOptionsContainer />}>
          <Button className="mx-1 flex items-center gap-2 h-[39px]">
            {/* {!isBrowserExt && "Sort"} */}
            <SortIcon />
          </Button>
        </Popover>
        <Popover
          placement="right"
          open={visible}
          onOpenChange={handleVisibleChange}
          content={
            <ActivityCenterFilter
              variables={variables}
              setVariables={setVariables}
              scrollListToTop={scrollListToTop}
              clearUrl={clearUrl}
              restrictRemoveDefaultFilter={restrictRemoveDefaultFilter}
              handleVisibleChange={handleVisibleChange}
              onClearAllFilters={onClearAllFilters}
            />
          }
          trigger="click"
          overlayInnerStyle={{ padding: 0 }}
        >
          <Tooltip placement="topLeft" title={lang.moreLeadFilters}>
            <Button className="flex items-center gap-2 h-[39px]">
              {/* {!isBrowserExt && "Filter"} */}
              <Badge count={filterCount} className="mt-2">
                <FilterIcon />
              </Badge>
            </Button>
          </Tooltip>
        </Popover>
      </div>
      <div className="flex-col-centered gap-1">
        <div className="flex items-center my-1 justify-between w-full">
          <Dropdown
            menu={{
              items: renderFilters,
            }}
            trigger="click"
          >
            <div className="flex-row-centered gap-2 cursor-pointer items-center">
              <CustomLabel label={lang.quickFilters} labelClass="font-normal text-[14px]" />{" "}
              <DownIcon />
            </div>
          </Dropdown>
          <Button
            onClick={() => {
              if (setVariables) {
                setVariables({
                  ...variables,
                  leadId: null,
                  page: 1,
                  campaignIds: [],
                });
              }
              dispatch(resetLeadFilters());
              if (restrictRemoveDefaultFilter) {
                dispatch(addQuickFilter(QUICK_FILTERS.MY_CONVERSATIONS));
              }
              scrollListToTop?.();
              clearUrl?.();
              onClearAllFilters?.();
            }}
            type="text"
            className="text-blue-500"
          >
            Clear all
          </Button>
        </div>
        {selectedQuickFilters.length > 0 && (
          <div className="flex-row-centered mb-1 mr-1">
            {(selectedQuickFilters || []).slice(0, 2).map((item, index) => {
              const filter = leadStatus.find(status => status.id === item);
              return (
                <Tag
                  className={`cursor-pointer flex-row-centered gap-1 border-none ${backgroundColor(
                    filter?.id
                  )}`}
                  onClose={() => {
                    if (
                      restrictRemoveDefaultFilter &&
                      filter?.id === QUICK_FILTERS.MY_CONVERSATIONS
                    )
                      return;
                    updateVariableContext();
                    dispatch(removeQuickFilter(filter?.id));
                    if (filter?.id === QUICK_FILTERS.MY_CONVERSATIONS)
                      dispatch(removeMyConversationFlag());
                  }}
                  key={index}
                >
                  <span>{filter?.name}</span>{" "}
                  {!(
                    restrictRemoveDefaultFilter && filter?.id === QUICK_FILTERS.MY_CONVERSATIONS
                  ) && (
                    <CloseOutlined
                      className="cursor-pointer"
                      onClick={() => {
                        updateVariableContext();
                        dispatch(removeQuickFilter(filter?.id));
                        if (filter?.id === QUICK_FILTERS.MY_CONVERSATIONS)
                          dispatch(removeMyConversationFlag());
                        scrollListToTop?.();
                        clearUrl?.();
                        onClearAllFilters?.();
                      }}
                    />
                  )}
                </Tag>
              );
            })}
            {(selectedQuickFilters || []).length > 2 && (
              <Dropdown
                menu={{
                  items: renderFilters,
                }}
                trigger="click"
              >
                <Tag className="cursor-pointer">+ {(selectedQuickFilters || []).length - 2}</Tag>
              </Dropdown>
            )}
          </div>
        )}
        <div className="h-[1px] mb-1 w-full bg-grey-200" />
      </div>
    </div>
  );
}

const findLastMessage = (messages, n = 0) => {
  // Base case: If the index is out of range, return null.
  if (n >= messages.length) return null;
  const message = messages[n];
  // Check if the message is valid and has non-empty content.
  if (message !== undefined && message !== null && message?.content !== "") {
    return message;
  }
  // Recursively check the next message.
  return findLastMessage(messages, n + 1);
};

function ListItem({
  item,
  selectedLead,
  setSummaryVisible,
  user,
  isFromChatbot,
  sourcesData,
  activeOpp,
  setActiveOpp,
  openAppointmentPopup,
  handleAppointmentModalClose,
  spinner,
  refetchLeads,
  setAttachments,
  setmessageText,
  setSelectedLead,
  changePage,
  messageFilters,
  setMessageFilters,
  setShowLeadSection,
  setOpportunityList,
  setFilterApplied,
  setSelectedLeadId,
  timeReference,
  setbtnClicked,
  handleLeadListDrawer,
  lang,
  setNoResponseNeededLoading,
  setLeadAsNoResponseNeeded,
  archivingLeadId,
  setArchivingLeadId,
  isPinLeadFromLeadCenter,
  handleUnpinLead,
  getDuplicateLeads = () => {},
  getMergedLead = () => {},
  removeMergedLead = () => {},
  showAll,
  leadData,
  setShowAll,
  canMergeOppor,
  opportunityStatusList,
  selectedOppTypeId,
  setSelectedOppTypeId = () => {},
  listFilterRootOppTypeIds = [],
}) {
  const dispatch = useDispatch();
  const [showArchive, setshowArchive] = useState(false);
  // True while this row's "Show All" merge fetch is in flight, so the banner can
  // show "Loading..." instead of flipping to "Close" before the data arrives.
  const [isMergeLoading, setIsMergeLoading] = useState(false);

  const handleToggleMerge = async () => {
    const isShowAll = showAll?.[item?.id] ?? true;
    if (!isShowAll) {
      // Currently expanded → collapse immediately (no API call).
      removeMergedLead(item?.mergeHistory, leadData);
      setShowAll(prev => ({ ...prev, [item?.id]: true }));
      return;
    }
    // Collapsed → fetch + append, holding "Loading..." until it resolves. Only
    // flip to "Close" on success so a failed fetch stays on "Show All".
    setIsMergeLoading(true);
    try {
      await getMergedLead(item, item?.mergeHistory, leadData);
      setShowAll(prev => ({ ...prev, [item?.id]: false }));
    } catch (error) {
      // Leave the banner on "Show All" so the user can retry; nothing was
      // appended on failure.
      console.error("[merge] failed to load merged leads", error);
    } finally {
      setIsMergeLoading(false);
    }
  };
  // Prefer the selected lead's freshly-fetched messages, but only once they've
  // actually loaded. While the server fetch is in flight selectedLead.messages is
  // empty — fall back to the list item's messages so we don't briefly flash
  // "No conversation yet" for the lead just clicked.
  const sortedMessages = (
    (selectedLead?.id === item?.id && selectedLead?.messages?.length > 0
      ? selectedLead?.messages
      : item?.messages) || []
  )
    .map(el => ({ ...el, recentDate: el?.dateReceived || el?.dateSent }))
    .sort((a, b) => {
      const dateA = dayjs(a?.recentDate);
      const dateB = dayjs(b?.recentDate);
      return dateB.isBefore(dateA) ? -1 : 1;
    });

  const lastMessage = findLastMessage(sortedMessages || [], 0);
  return (
    <>
      <List.Item
        key={item?.id}
        className={`leadBox border-solid border-l-[6px] border-[1px] mt-3 p-3 mr-2 rounded-[4px] ${
          selectedLead && +selectedLead?.id === +item?.id ? "selectedLeadClass" : "none"
        } ${item.isDeleted ? "bg-[#FEF2F2]" : ""}`}
        onMouseEnter={() => setshowArchive(true)}
        onMouseLeave={() => setshowArchive(false)}
        style={{
          // Strip color obeys product-spec priority — see
          // `resolveLeadStripStatus` at module scope.
          borderLeftColor: getQuickFilterDotColor(resolveLeadStripStatus(item)),
          // borderLeftColor: colorCode[item?.messageStatusType?.status]
          //   ? colorCode[item?.messageStatusType?.status]
          //   : "#22C55E",
        }}
        onClick={() => {
          setSummaryVisible &&
            setSummaryVisible({
              visible: false,
              count: 0,
            });
        }}
      >
        <List.Item.Meta
          title={
            <TitleComponent
              item={item}
              lang={lang}
              showArchive={showArchive}
              setNoResponseNeededLoading={setNoResponseNeededLoading}
              setLeadAsNoResponseNeeded={setLeadAsNoResponseNeeded}
              archivingLeadId={archivingLeadId}
              setArchivingLeadId={setArchivingLeadId}
              isPinLeadFromLeadCenter={isPinLeadFromLeadCenter}
              handleUnpinLead={handleUnpinLead}
              opportunityStatusList={opportunityStatusList}
              selectedOppTypeId={selectedOppTypeId}
              selectedLead={selectedLead}
              user={user}
            />
          }
          description={
            <LeadList
              messageObject={lastMessage}
              user={user}
              item={item}
              isFromChatbot={isFromChatbot}
              sourcesData={sourcesData}
              activeOpp={activeOpp}
              setActiveOpp={setActiveOpp}
              openAppointmentPopup={openAppointmentPopup}
              handleAppointmentModalClose={handleAppointmentModalClose}
              spinner={spinner}
              selectedLeadId={selectedLead?.id}
              refetchLeads={refetchLeads}
              selectedLead={selectedLead}
              selectedOppTypeId={selectedOppTypeId}
              listFilterRootOppTypeIds={listFilterRootOppTypeIds}
            />
          }
          onClick={() => {
            setAttachments([]);
            setmessageText("");
            if (+selectedLead?.id === +item?.id) {
              return;
            }
            // Different lead selected — any AI suggestion in the slice belongs
            // to the previous lead and is no longer valid. Clear both channels
            // so the next createMessage / createMms / createEmail doesn't
            // accidentally tag the new lead with the old lead's AI ID.
            dispatch(resetAiResponseHistoryIds());
            localStorage.getItem("changedLocationLeadId") &&
              localStorage.removeItem("changedLocationLeadId");
            // Seed the active tab from the NEW lead's most-recent
            // permitted opp BEFORE setSelectedLead fires. Uses the same
            // helper as the lead-card render so the row's data and the
            // detail panel's tab stay in sync.
            //
            // Always reset (not just when null) — otherwise the prior
            // lead's tab carries over to the next click. With the
            // selected-row exception in the card, that stale tab would
            // briefly drive the new row's content for one render cycle
            // (flicker) until the engagementActivity useEffect runs and
            // overwrites it with the new lead's correct tab. Setting
            // both atomically here eliminates the in-between render.
            const nextTab = getMostRecentPermittedRootOppTypeId(item, user);
            setSelectedOppTypeId(nextTab || null);
            setSelectedLead({ ...item });

            changePage();

            const dummyPayload = { ...messageFilters };
            delete dummyPayload.leadOpportunityId;
            setMessageFilters({
              ...dummyPayload,
              page: 1,
              leadId: item?.id,
              lastId: "",
            });
            setShowLeadSection(false);
            setOpportunityList([
              {
                filterId: null,
                id: "#DEFAULTOPPID",
                name: "All",
              },
            ]);
            setFilterApplied(false);
            setActiveOpp("#DEFAULTOPPID");
            setSelectedLeadId(item?.id);
            clearTimeout(timeReference);
            setbtnClicked(false);
            handleLeadListDrawer();
          }}
        />
      </List.Item>
      {item?.potentialLeads?.length > 0 && (
        <div className="bg-[#E2E8F0] flex justify-center items-center mr-[8px]">
          <span className="text-[#EF4444]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={13}
              height={12}
              fill="none"
              className="mr-2"
            >
              <path
                fill="#EF4444"
                d="M12.5 4.5a.5.5 0 0 1-.336.473L1 8.856V11.5a.5.5 0 1 1-1 0V.5A.5.5 0 0 1 .664.028l11.5 4a.5.5 0 0 1 .336.472Z"
              />
            </svg>
            Duplicate record found for this lead.
          </span>
          {canMergeOppor && (
            <span
              className="text-[#3B82F6] ml-1 cursor-pointer"
              onClick={() => {
                getDuplicateLeads(item, item?.potentialLeads);
                setSelectedLeadId(item?.id);
              }}
            >
              Merge It
            </span>
          )}
        </div>
      )}
      {item?.mergeHistory?.length > 0 && (
        <div className="bg-[#334155] flex justify-center items-center mr-[8px]">
          <span className="text-[#FFF]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={17}
              height={16}
              fill="none"
              className="mr-2"
            >
              <path
                fill="#fff"
                d="M16 6.5a.5.5 0 0 1-.336.473L4.5 10.856V13.5a.5.5 0 1 1-1 0v-11a.5.5 0 0 1 .664-.472l11.5 4A.5.5 0 0 1 16 6.5Z"
              />
            </svg>
            This is merged lead
          </span>
          <span
            className={`text-[#93C5FD] ml-1 ${
              isMergeLoading ? "opacity-60 cursor-default" : "cursor-pointer"
            }`}
            onClick={() => {
              // Keyed by stable lead id (not list index `i`) so appending merged
              // children / re-ordering / pagination can't shift a flag onto the
              // wrong lead. Absent id = collapsed → "Show All" by default.
              if (!isMergeLoading) handleToggleMerge();
            }}
          >
            {isMergeLoading ? "Loading..." : showAll?.[item?.id] ?? true ? "Show All" : "Close"}
          </span>
        </div>
      )}
    </>
  );
}

const TitleComponent = ({
  item,
  lang,
  setNoResponseNeededLoading,
  setLeadAsNoResponseNeeded,
  archivingLeadId,
  setArchivingLeadId,
  isPinLeadFromLeadCenter,
  handleUnpinLead,
  showArchive,
  opportunityStatusList,
  selectedOppTypeId,
  selectedLead,
  user,
}) => {
  // Lead card normally reflects THIS lead's most-recent permitted
  // root opp — derived from ``item.leadOpportunities`` already in
  // the getLeads payload. Keeps the row stable on click.
  //
  // Exception: when this row IS the currently-selected lead AND the
  // user has explicitly switched the detail-panel tab, honor that
  // tab so the selected row stays in sync with the right panel.
  const isThisLeadSelected = +item?.id === +selectedLead?.id;
  const effectiveOppTypeId =
    isThisLeadSelected && selectedOppTypeId
      ? selectedOppTypeId
      : getMostRecentPermittedRootOppTypeId(item, user);
  const scopedOpps = effectiveOppTypeId
    ? (item?.leadOpportunities || []).filter(opp => oppMatchesTab(opp, effectiveOppTypeId))
    : item?.leadOpportunities || [];
  const latestOpportunity = orderBy(scopedOpps, opp => new Date(opp?.updatedDate), "desc")[0];
  let leadDate = item?.leadCreatedDate
    ? parseTimestamp(dayjs.utc(item?.leadCreatedDate).local())
    : parseTimestamp(new Date());

  const sortedMessages = (item?.messages || [])
    .map(el => ({ ...el, recentDate: el?.dateReceived || el?.dateSent }))
    .sort((a, b) => {
      const dateA = dayjs(a?.recentDate);
      const dateB = dayjs(b?.recentDate);
      return dateB.isBefore(dateA) ? -1 : 1;
    });

  if ((sortedMessages || []).length > 0) {
    const lastMsgLead = !isUndefined(sortedMessages[0]?.id) ? sortedMessages[0] : sortedMessages[1];
    leadDate = lastMsgLead?.dateReceived
      ? parseTimestamp(dayjs.utc(lastMsgLead?.dateReceived).local())
      : parseTimestamp(dayjs.utc(lastMsgLead?.dateSent).local());
  }

  return (
    <div className="flex flex-col">
      <div className="flex justify-between">
        <div className="flex-col-centered w-[70%] items-start justify-start">
          <div className="flex items-center gap-2 w-full min-w-0">
            <Tooltip title={item?.fullName || ""} placement="topLeft">
              <span className="text-grey-700 ellipsis flex-shrink min-w-0">
                {item?.fullName || ""}
              </span>
            </Tooltip>
            {/* One small icon per root opp_type the lead actually has.
                The ``effectiveOppTypeId`` (this lead's most-recent
                permitted root, or the active tab when this row IS the
                selected lead) gets a tinted chip; the others render as
                bare strokes so the row signals "Sales AND Service
                opps exist, here's which one's active." */}
            <LeadOppTypeIcons lead={item} highlightedRootId={effectiveOppTypeId} />
          </div>
          <Tooltip
            title={getOpportunityStatusPath(
              opportunityStatusList,
              latestOpportunity?.opportunityStatus?.id
            )}
          >
            <span className={`text-xs ${statusColor(latestOpportunity?.opportunityStatus?.name)}`}>
              {latestOpportunity?.opportunityStatus?.name}
            </span>
          </Tooltip>
        </div>
        <div className="flex-col-centered w-[30%] items-end">
          <CustomLabel
            label={<div className="text-[12px] font-[400]">{` ${leadDate}`}</div>}
            labelClass="text-[#333] text-end"
          />{" "}
          <span
            onClick={e => {
              e.stopPropagation();
              if (archivingLeadId === item?.id) return;
              const isArchiveAction = item?.messageStatusType?.status !== "NO_RESPONSE_NEEDED";
              const archiveLead = () => {
                setArchivingLeadId(item?.id);
                setNoResponseNeededLoading(true);
                setLeadAsNoResponseNeeded({
                  variables: {
                    leadId: item?.id,
                    isNoResponseNeeded: isArchiveAction,
                  },
                });
              };

              if (getLocalStorage(SKIP_ARCHIVE_RESTORE_CONFIRMATION_KEY) === true) {
                archiveLead();
                return;
              }

              let dontAskAgain = false;
              Modal.confirm({
                title: "Are you sure?",
                icon: <ExclamationCircleFilled />,
                content: (
                  <div>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: `${`${
                          isArchiveAction
                            ? lang.noResponseNeededConfirmationMessage
                            : lang.restoreConfirmationMessage
                        }`.replace("__leadName__", item?.fullName)}`,
                      }}
                    />
                    <div className="mt-3 pt-3 border-0 border-t border-solid border-grey-200">
                      <Checkbox
                        onChange={ev => {
                          dontAskAgain = ev.target.checked;
                        }}
                      >
                        <span className="font-[500]">Don&apos;t ask me again</span>
                      </Checkbox>
                      <p className="text-xs text-grey-500 mt-1 mb-0 ml-6">
                        Future <strong>archive</strong> and <strong>restore</strong> actions will be
                        performed directly without this confirmation. You can re-enable the
                        confirmation anytime from your Personal Profile settings.
                      </p>
                    </div>
                  </div>
                ),
                onOk() {
                  if (dontAskAgain) {
                    setLocalStorage(SKIP_ARCHIVE_RESTORE_CONFIRMATION_KEY, true);
                  }
                  archiveLead();
                },
                onCancel() {},
              });
            }}
            className={`cursor-pointer flex-row-centered gap-1 items-center ${
              item?.messageStatusType?.status === "NO_RESPONSE_NEEDED" ||
              showArchive ||
              archivingLeadId === item?.id
                ? "visible"
                : "invisible"
            } ${archivingLeadId === item?.id ? "pointer-events-none opacity-80" : ""}`}
          >
            {archivingLeadId === item?.id ? (
              <LoadingOutlined className="text-brand-600" />
            ) : item?.messageStatusType?.status === "NO_RESPONSE_NEEDED" ? (
              <RestoreArchiveIcon />
            ) : (
              <ArchiveIcon />
            )}
            <span className="text-xs font-[400] text-brand-600">
              {archivingLeadId === item?.id
                ? item?.messageStatusType?.status === "NO_RESPONSE_NEEDED"
                  ? "Restoring..."
                  : "Archiving..."
                : item?.messageStatusType?.status === "NO_RESPONSE_NEEDED"
                ? "Restore"
                : "Archive"}
            </span>
          </span>
        </div>

        {isPinLeadFromLeadCenter && (
          <Tooltip title="Remove lead">
            <AntdIconV4
              type="PushpinFilled"
              style={{ color: "#334155", marginTop: "4px", marginLeft: "12px", alignSelf: "start" }}
              ml={4}
              onClick={() => handleUnpinLead(item)}
            />
          </Tooltip>
        )}
      </div>

      <div className="w-full my-2 h-[1px] bg-[#cbd5e1]" />
    </div>
  );
};
